import type { PrefetchContext, PrefetchedDataProps } from '#src/shared/prefetch';

import type { MergedState } from '#src/app/shared/hooks/state';
import { useMergedStates } from '#src/app/shared/hooks/state';

import { prefetchEndorsementsLayoutPageDataFromApi, useEndorsementsLayoutPageDataFromApi } from './pageData';

export type EndorsementsPagePrefetchedContext = Readonly<{
	pageData: Parameters<typeof useEndorsementsLayoutPageDataFromApi>[0];
}>;

export type EndorsementsPageCombinedState = MergedState<ReturnType<typeof useEndorsementsLayoutPageDataFromApi>>;

export function useEndorsementsPageContextState(
	slug: string,
	prefetchedData?: EndorsementsPagePrefetchedContext,
): EndorsementsPageCombinedState {
	return useMergedStates(useEndorsementsLayoutPageDataFromApi(prefetchedData?.pageData, { slug }));
}

export async function prefetchPageContext(context: PrefetchContext): Promise<EndorsementsPagePrefetchedContext> {
	const { slug } = context.params;
	if (slug === undefined) {
		throw new Error('prefetchPageContext: missing slug route param');
	}

	const [pageData] = await Promise.all([
		prefetchEndorsementsLayoutPageDataFromApi(context, {
			slug,
		}),
	]);

	return { pageData };
}

export type EndorsementsPagePrefetchedDataProps = PrefetchedDataProps<EndorsementsPagePrefetchedContext>;
